import type { LinkedinConnectionType } from '../linkedinConnectionTypes';
import { linkedinConnectionTypes } from '../linkedinConnectionTypes';
import { linkedinURLRegExp } from '../linkedinURLPattern';

type LinkedinParsedSourceType = 'company' | 'showcase' | 'school' | 'in';

const LinkedinConnectionKeys: Record<
  LinkedinParsedSourceType,
  LinkedinConnectionType
> = {
  company: linkedinConnectionTypes.company,
  showcase: linkedinConnectionTypes.company,
  school: linkedinConnectionTypes.company,
  in: linkedinConnectionTypes.profile
};

export const parseLinkedinSource = (url: string) => {
  const [, parsedType, parsedSource] = url.match(linkedinURLRegExp) ?? [];

  const connectionKey =
    LinkedinConnectionKeys[parsedType as LinkedinParsedSourceType];

  return {
    connectionKey,
    source: parsedSource
  };
};
